import { useGlobalState } from '@exodus/headless-react';
import { useEffect } from 'react';
const DEFAULT_CONFIG = {
    defaultFromAsset: 'bitcoin',
    defaultToAsset: 'ethereum',
};
const useConfig = (value) => {
    const [config, setConfig] = useGlobalState({
        namespace: 'exchange',
        key: 'config',
        defaultValue: { ...DEFAULT_CONFIG, ...value },
    });
    useEffect(() => {
        if (value)
            setConfig({ ...DEFAULT_CONFIG, ...value });
    }, [setConfig, value]);
    return config;
};
export default useConfig;
